<div class="padding-dialog">

  <div class='flex justify-between items-center event-box'>
    <mat-icon class="svg-icon" svgIcon="edit"></mat-icon>
    <div>
      <h1 mat-dialog-title>Modifica anni di riferimento</h1>

    </div>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>clear</mat-icon>
    </button>
  </div>
  <div mat-dialog-content class="spin-theme">
    <smart-form [fields]="fields"></smart-form>
  </div>




  <div mat-dialog-actions align="center">

    <button mat-flat-button color="accent" [disabled]="!smartFormComponent?.form?.valid"
      (click)="edit()">Modifica</button>
    <button mat-flat-button mat-dialog-close cdkFocusRegionStart>Annulla</button>

  </div>
</div>